module.exports = __webpack_public_path__ + "img/icon3.38edcd5a.svg";